import React from 'react';
import { useSelector } from 'react-redux'
import CouponContainer from '../../coupon/containers/CouponContainer';
import TicketPickerPage from './TicketPickerPage';
import { showPresaleCouponForm } from '../../coupon/selectors/coupon';
import { MemberLogin } from "@checkout-b/listing/components/MemberLogin";
import { withRouterCompat } from '@checkout-h/withRouterCompat';

const EmbeddedTicketPicker = props => {
    const isCouponRoute = props.currentRouteName === 'coupon';
    const overlay       = useSelector(state => !!state.ui.overlay);
    const showPresale   = useSelector(state => showPresaleCouponForm(state));

    const isMembershipAvailable = !!useSelector(state => state.ui?.uiConfig?.membershipFormConfig?.membership_available);
    const isMembershipSkipped = !!useSelector(state => state.ui?.skipMembership);
    const hasMembershipInstance = !!useSelector(state => state.reservation?.hasMembershipInstance);

    const showMembership = isMembershipAvailable && !isMembershipSkipped && !hasMembershipInstance;
    const showCouponContainer = (isCouponRoute || showPresale) && !overlay;

    if (showMembership) {
      return <MemberLogin />;
    }

    return (showCouponContainer)
      ? <CouponContainer asOverlay={false} canCancelPresale={false}/>
      : <TicketPickerPage isEmbeddedPicker/>;
}

export default withRouterCompat(EmbeddedTicketPicker);
